<section class="ms-5 me-5" *ngIf="meeting?.id && type ">
    <super-title [text]="meeting.description" level="1" [sub]="type|translate" [hasSubtitle]="true"
        icon="fas fa-arrow-circle-left" (iconClick)="back($event)"></super-title>
    <app-editor [meetingID]="meeting.id" [typeRTF]="type"></app-editor>
</section>